import { render, staticRenderFns } from "./publishingBlockchainDialog.vue?vue&type=template&id=19311d2c&scoped=true"
import script from "./publishingBlockchainDialog.vue?vue&type=script&lang=js"
export * from "./publishingBlockchainDialog.vue?vue&type=script&lang=js"
import style0 from "./publishingBlockchainDialog.vue?vue&type=style&index=0&id=19311d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19311d2c",
  null
  
)

export default component.exports